import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { MessagesIndex } from './screens/Index'


function MessagesRoutes() {
  return (
    <Switch>
      <Route component={MessagesIndex} />
    </Switch>
  )
}

export { MessagesRoutes }
